import GenericFormContainer from "../../containers/GenericFormContainer";

const GenericFormPage = () => {
  return <GenericFormContainer />;
};

export default GenericFormPage;
